// App.jsx
import { Outlet, Link, useNavigate } from "react-router-dom";
import bluePinPng from "leaflet/dist/images/marker-icon.png";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { useEffect, useState } from "react";
import { getCurrentUser, fetchUserAttributes } from "@aws-amplify/auth";

function App() {
  const navigate = useNavigate();
  const { user, signOut: authSignOut } = useAuthenticator((context) => [
    context.user,
  ]);
  const [fullName, setFullName] = useState(null);

  useEffect(() => {
    const loadUserAttributes = async () => {
      if (!user) {
        setFullName(null);
        return;
      }
      try {
        const currentUser = await getCurrentUser();
        const attributesObj = await fetchUserAttributes(currentUser);
        // normalize: attributesObj might be array or object
        const attributes = Array.isArray(attributesObj)
          ? attributesObj
          : Object.entries(attributesObj).map(([Name, Value]) => ({
              Name,
              Value,
            }));

        const firstName = attributes.find(
          (a) => a.Name === "given_name"
        )?.Value;
        const lastName = attributes.find(
          (a) => a.Name === "family_name"
        )?.Value;
        if (firstName && lastName) {
          setFullName(`${firstName} ${lastName}`);
        } else {
          setFullName(null);
        }
      } catch (err) {
        console.error("Error fetching user attributes:", err);
        setFullName(null);
      }
    };

    loadUserAttributes();
  }, [user]);

  const handleSignOut = async () => {
    try {
      await authSignOut();
      navigate("/");
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center bg-gray-50">
      <header className="bg-white shadow sticky top-0 z-50 w-full flex justify-center">
        <div className="flex items-center justify-between py-4 px-6 w-full">
          <Link to="/" className="flex items-center gap-2">
            <img src={bluePinPng} alt="Logo" className="h-8 w-5" />
            <span className="text-xl font-bold tracking-tight text-gray-800">
              Brokerage Insights
            </span>
          </Link>
          {user && (
            <div className="flex items-center gap-4">
              {fullName && (
                <span className="text-gray-600">Welcome, {fullName}</span>
              )}
              <button
                onClick={handleSignOut}
                className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300"
              >
                Sign Out
              </button>
            </div>
          )}
        </div>
      </header>
      <main className="flex-1 flex flex-col items-center justify-center w-full px-4 py-8">
        <div className="w-full">
          <Outlet />
        </div>
      </main>
      <footer className="bg-white border-t py-4 text-center text-gray-400 text-sm w-full flex justify-center">
        <div className="w-full">
          &copy; {new Date().getFullYear()} Truplis. All rights reserved.
        </div>
      </footer>
    </div>
  );
}

export default App;
